import imageUrlBuilder from "@sanity/image-url";
import { client } from "./sanity";

const builder = imageUrlBuilder(client);

// Your existing function - keep for backward compatibility
export function urlForImage(source) {
  if (!source?.asset) {
    const fallback = {
      url: () => '/assets/img/fallback-image.jpg',
      width: () => fallback,
      height: () => fallback,
      fit: () => fallback,
      auto: () => fallback,
    };
    return fallback;
  }
  return builder.image(source);
}

// New enhanced function using Sanity's official vanity filename approach
export function urlForImageWithVanity(source, vanityFilename = null) {
  if (!source?.asset) return "";

  const baseUrl = builder.image(source).url();

  // Get vanity filename using Sanity's recommended approach
  const filename =
    vanityFilename ||
    source?.asset?.originalFilename ||
    source?.originalFilename;

  // Append vanity filename as per Sanity documentation
  return filename ? `${baseUrl}/${filename}` : baseUrl;
}
